import { usePolarisVizContext, DEFAULT_CHART_PROPS } from '@shopify/polaris-viz-core';
import { Chart } from './Chart.js';
import { jsx } from 'react/jsx-runtime';
import { ChartContainer } from '../ChartContainer/ChartContainer.js';

function DonutChart(props) {
  const {
    defaultTheme
  } = usePolarisVizContext();
  const {
    data,
    theme = defaultTheme,
    comparisonMetric,
    showLegend = true,
    labelFormatter = value => `${value}`,
    legendFullWidth,
    legendPosition = 'left',
    onError,
    isAnimated,
    state,
    errorText,
    renderInnerValueContent,
    renderLegendContent
  } = { ...DEFAULT_CHART_PROPS,
    ...props
  };
  return /*#__PURE__*/jsx(ChartContainer, {
    skeletonType: "Donut",
    data: data,
    onError: onError,
    theme: theme,
    isAnimated: isAnimated,
    children: /*#__PURE__*/jsx(Chart, {
      errorText: errorText,
      state: state,
      data: data,
      labelFormatter: labelFormatter,
      comparisonMetric: comparisonMetric,
      showLegend: showLegend,
      legendFullWidth: legendFullWidth,
      legendPosition: legendPosition,
      renderInnerValueContent: renderInnerValueContent,
      renderLegendContent: renderLegendContent,
      theme: theme
    })
  });
}

export { DonutChart };
